module.exports = __webpack_public_path__ + "static/dcms-footer-logo-d976ccbd5f298f2c5c03038bc6f6dedb.png";